import { render, staticRenderFns } from "./IndagineEpidemiologicaCambiaStatoModalComponent.vue?vue&type=template&id=21adc1ee"
import script from "./IndagineEpidemiologicaCambiaStatoModalComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaCambiaStatoModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports